import { DefaultTheme } from "styled-components";

export const defaultTheme: DefaultTheme = {
  colors: {},
};
